import { ENV } from "../Utils";

export class InstitutionApi {
  baseApi = ENV.BASE_API;

  async createInstitution(accessToken, formValue) {
    //console.log("formValue", formValue);
    try {
      const formData = new FormData();

      // Añadimos los datos comunes del usuario

      formData.append("avatar", formValue.fileAvatar);
      formData.append("firstname", formValue.firstname);
      formData.append("lastname", formValue.lastname);
      formData.append("email", formValue.email);
      formData.append("password", formValue.password);
      formData.append("role", formValue.role);
      formData.append("partnerId", formValue.partnerId);
      formData.append("active", false);
      // Datos adicionales específicos de la institución
      formData.append("institutionnam", formValue.institutionnam);
      formData.append("address", formValue.address);
      formData.append("city", formValue.city);
      formData.append("country", formValue.country);
      formData.append("phone", formValue.phone);
      formData.append("website", formValue.website);
      formData.append("plan", formValue.plan);
      formData.append("studentsnum", formValue.studentsnum);
      formData.append("teachersnum", formValue.teachersnum);

      // Agregamos idClient y active solo si están presentes
      if (formValue.idClient) {
        formData.append("idClient", formValue.idClient);
      }
      if (formValue.active !== undefined) {
        formData.append("active", formValue.active);
      }

      // Configuración de la solicitud
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/create`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      // Enviamos la solicitud
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message); // Manejo de error si no es 200 OK
      }

      return result; // Retorna el resultado en caso de éxito
    } catch (error) {
      console.error("Error en createInstitution:", error);
    }
  }

  async getInstitutions(accessToken, user, active = undefined) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/get/${user.user._id}/?active=${active}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async updateInstitution(accessToken, idInstitution, userData) {
    console.log("formValue", userData);
    try {
      const formValue = userData;
      //console.log("data", data);
      const formData = new FormData();
      // Añadir campos solo si están presentes en formValue
      if (formValue.fileAvatar) formData.append("avatar", formValue.fileAvatar);
      if (formValue.firstname)
        formData.append("firstname", formValue.firstname);
      if (formValue.lastname) formData.append("lastname", formValue.lastname);
      if (formValue.email) formData.append("email", formValue.email);
      if (formValue.password) formData.append("password", formValue.password);
      if (formValue.role) formData.append("role", formValue.role);
      if (formValue.partner) formData.append("partnerId", formValue.partnerId);
      // Datos adicionales específicos de la institución
      if (formValue.institutionnam)
        formData.append("institutionnam", formValue.institutionnam);
      if (formValue.address) formData.append("address", formValue.address);
      if (formValue.city) formData.append("city", formValue.city);
      if (formValue.country) formData.append("country", formValue.country);
      if (formValue.phone) formData.append("phone", formValue.phone);
      if (formValue.website) formData.append("website", formValue.website);
      if (formValue.plan) formData.append("plan", formValue.plan);
      if (formValue.studentsnum)
        formData.append("studentsnum", formValue.studentsnum);
      if (formValue.teachersnum)
        formData.append("teachersnum", formValue.teachersnum);

      // Agregar idClient solo si está presente
      if (formValue.idClient) {
        formData.append("idClient", formValue.idClient);
      }

      //console.log("formData", formData);
      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.INSTITUTION}/${idInstitution}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async updateInstitutionActive(accessToken, idInstitution, institutionData) {
    try {
      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.INSTITUTION}/${idInstitution}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json", // Añadir el Content-Type correcto
        },
        body: JSON.stringify(institutionData),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteInstitution(accessToken, idInsitution) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/${idInsitution}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteAvatar(accessToken, avatarUrl) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/delete-avatar`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ avatarUrl }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }
}
